import { makeCompositeRequestMetadataExtensionsResolver } from "@lg-plus/landing-modules/lg-api";
import { makeGa4RequestMetadataExtensionResolver } from "../../shared/integrations/Google/GA4/request-metadata-extension.js";
export const makeDefaultRequestMetadataExtensionsResolver = (config) => {
    const ga4MeasurementId = config.ga4MeasurementId?.trim();
    return makeCompositeRequestMetadataExtensionsResolver([
        ...(ga4MeasurementId ? [makeGa4RequestMetadataExtensionResolver(ga4MeasurementId)] : []),
    ]);
};
